
const TaskList = () => {
    return (
        <div className="task_list_screen">
            <div className="list_area">
                <div className="item active">
                    <h4>Diagnosing and Treating</h4>
                    <div className="left_area">
                        <p>Assigned to :</p>
                        <div className="name_tag_area">
                            <p>Robert William</p>
                            <p className="tag">Nurse</p>
                        </div>
                    </div>
                    <div className="right_area">
                        <p>Assigned by :</p>
                        <div className="name_tag_area">
                            <p>Robert William</p>
                            <p className="tag">Consultant</p>
                        </div>
                    </div>
                </div>
                <div className="item">
                    <h4>Diagnosing and Treating</h4>
                    <div className="left_area">
                        <p>Assigned to :</p>
                        <div className="name_tag_area">
                            <p>Robert William</p>
                            <p className="tag">Nurse</p>
                        </div>
                    </div>
                    <div className="right_area">
                        <p>Assigned by :</p>
                        <div className="name_tag_area">
                            <p>Robert William</p>
                            <p className="tag">Consultant</p>
                        </div>
                    </div>
                </div>
                <div className="item">
                    <h4>Diagnosing and Treating</h4>
                    <div className="left_area">
                        <p>Assigned to :</p>
                        <div className="name_tag_area">
                            <p>Robert William</p>
                            <p className="tag">Nurse</p>
                        </div>
                    </div>
                    <div className="right_area">
                        <p>Assigned by :</p>
                        <div className="name_tag_area">
                            <p>Robert William</p>
                            <p className="tag">Consultant</p>
                        </div>
                    </div>
                </div>
                <div className="item">
                    <h4>Diagnosing and Treating</h4>
                    <div className="left_area">
                        <p>Assigned to :</p>
                        <div className="name_tag_area">
                            <p>Robert William</p>
                            <p className="tag">Nurse</p>
                        </div>
                    </div>
                    <div className="right_area">
                        <p>Assigned by :</p>
                        <div className="name_tag_area">
                            <p>Robert William</p>
                            <p className="tag">Consultant</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TaskList;